/**
 * The base a converted panel's store extends: a revision counter React can
 * subscribe to.
 *
 * The pattern every panel follows: mutate fields through store methods that
 * end in touch(); the Main component calls usePanelRevision(store) once and
 * then reads fields directly in render. Wholesale, like the old refresh() -
 * but React reconciliation replaces the clear-and-rebuild, so a button under
 * the pointer is never recreated out from under it.
 */

export class PanelState {
  private listeners = new Set<() => void>()
  private rev = 0

  /** Announce that state moved. Cheap; batches within a frame are fine. */
  protected touch(): void {
    this.rev++
    for (const fn of [...this.listeners]) fn()
  }

  readonly subscribe = (fn: () => void): (() => void) => {
    this.listeners.add(fn)
    return () => {
      this.listeners.delete(fn)
    }
  }

  readonly revision = (): number => this.rev
}
